// components/TemplateSelector.js
import React from 'react';

const TemplateSelector = ({ templates, selectedTemplate, onTemplateSelect }) => {
  return (
    <div className="mb-6">
      <h2 className="text-lg font-semibold mb-3">템플릿 선택</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {templates.map((template, index) => (
          <button
            key={index}
            onClick={() => onTemplateSelect(index)}
            className={`p-3 rounded-lg border-2 text-sm font-medium transition-all ${
              selectedTemplate === index 
                ? 'border-blue-500 bg-blue-50 text-blue-700' 
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            {template.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TemplateSelector;